import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromRoot from '../../reducers';
import * as mobileMenu from '../../actions/mobile-menu';

import { TealiumUtagService } from '../../tealium/utag.service';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'edge-global-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class GlobalHeaderComponent implements OnInit {
  isOpen$: Observable<boolean>;
  showDropdown$: Observable<boolean>;
  showProductDropdown = false;
  @ViewChild('productsTab') productsTab: any;
  showNews = false;
  environment = environment;

  constructor(
    private store: Store<fromRoot.State>,
    private tealium: TealiumUtagService
  ) {
    this.isOpen$ = store.select(fromRoot.isOpen);
    this.showDropdown$ = store.select(fromRoot.webPlayerDropdown);
  }

  ngOnInit(): void {
    if (!environment.production) {
      this.showNews = true;
    }
  }

  toggleMobileMenu(arg: boolean): void {
    this.store.dispatch(mobileMenu.ToggleMobileMenuAction(arg));
  }

  /**
   * Toggle the product dropdown menu to display the sports
   */
  toggleProductDropdown(evt: TouchEvent | MouseEvent): void {
    if (evt.type === 'mouseenter') {
      this.productsTab.nativeElement.classList.add('hovered');
    } else if (evt.type === 'mouseleave') {
      this.productsTab.nativeElement.classList.remove('hovered');
    } else if (evt.type === 'touchstart') {
      this.productsTab.nativeElement.classList.toggle('hovered');
    }
  }

  tealiumLink(event: Event): void {
    event.stopPropagation();

    this.tealium.link({
      tealium_event: 'outbound_clicks'
    });

    let goArmyUrl = 'https://www.goarmy.com/?iom=AFOD-2675107_GER_Football';

    if (window.location.href.includes('soccer')) {
      goArmyUrl = 'https://www.goarmy.com/?iom=AFOD-2675107_GER_Soccer';
    }

    window.open(goArmyUrl);
  }
}
